const GALLERY_PLACEHOLDERS = [
  { icon: "📸", label: "Foto principal" },
  { icon: "🌹", label: "Foto 2" },
  { icon: "💍", label: "Foto 3" },
  { icon: "🥂", label: "Foto 4" },
  { icon: "🌿", label: "Foto 5" },
  { icon: "✨", label: "Foto 6" },
  { icon: "🕊️", label: "Foto 7" },
];

const ROTATIONS = [-2.5, 1.8, -1.2, 2.1, -0.8, 1.5, -2.0, 1.0, -1.7, 2.3];

function initGallery() {
  const track = document.getElementById("carousel-track");
  const dotsEl = document.getElementById("carousel-dots");
  const prevBtn = document.getElementById("carousel-prev");
  const nextBtn = document.getElementById("carousel-next");
  const viewport = document.getElementById("carousel-viewport");
  if (!track) return;

  const items =
    typeof CONFIG !== "undefined" && CONFIG.galleryPhotos?.length
      ? CONFIG.galleryPhotos
      : GALLERY_PLACEHOLDERS;

  const total = items.length;
  if (total === 0) return;

  // ── Construir tarjetas ────────────────────────────────────
  function buildCard(item, realIndex) {
    const card = document.createElement("div");
    card.className = "carousel-card";
    card.dataset.realIndex = realIndex;
    card.style.setProperty(
      "--card-rotate",
      `${ROTATIONS[realIndex % ROTATIONS.length]}deg`,
    );

    if (item.src) {
      const img = document.createElement("img");
      img.className = "carousel-card-img";
      img.src = item.src;
      img.alt = item.caption || `Foto ${realIndex + 1}`;
      img.draggable = false;
      card.appendChild(img);
    } else {
      const ph = document.createElement("div");
      ph.className = "carousel-card-placeholder";
      ph.innerHTML = `<span>${item.icon || "📸"}</span>${item.label || ""}`;
      card.appendChild(ph);
    }

    if (item.caption) {
      const cap = document.createElement("div");
      cap.className = "carousel-card-caption";
      cap.textContent = item.caption;
      card.appendChild(cap);
    }

    card.addEventListener("click", () => {
      if (card.classList.contains("active")) {
        openLightbox(realIndex);
      } else {
        goToReal(realIndex);
        resetAutoTimer();
      }
    });

    return card;
  }

  for (let i = 0; i < total; i++) track.appendChild(buildCard(items[i], i));
  for (let i = 0; i < total; i++) track.appendChild(buildCard(items[i], i));
  for (let i = 0; i < total; i++) track.appendChild(buildCard(items[i], i));

  // trackIndex del original de realIndex (siempre en bloque 2)
  function origTI(realIndex) {
    return total + realIndex;
  }

  // ── Dots ─────────────────────────────────────────────────
  const dots = [];
  items.forEach((_, i) => {
    const dot = document.createElement("div");
    dot.className = "carousel-dot";
    dot.addEventListener("click", () => {
      goToReal(i);
      resetAutoTimer();
    });
    dotsEl.appendChild(dot);
    dots.push(dot);
  });

  // ── Estado ───────────────────────────────────────────────
  let currentTI = origTI(0); // trackIndex actual
  let isAnimating = false;

  function offsetForTI(ti) {
    const card = track.children[ti];
    if (!card) {
      return 0;
    }
    const prevTransform = track.style.transform;
    track.style.transform = "none";
    const cardLeft = card.offsetLeft;
    const cardW = card.offsetWidth;
    track.style.transform = prevTransform;

    const vpW = viewport.offsetWidth;
    return cardLeft - (vpW / 2 - cardW / 2);
  }

  function setTransform(ti, animated) {
    if (!animated) track.classList.add("no-transition");
    track.style.transform = `translateX(${-offsetForTI(ti)}px)`;
    if (!animated) {
      void track.offsetWidth;
      track.classList.remove("no-transition");
    }
  }

  function updateActive() {
    const real = parseInt(track.children[currentTI]?.dataset.realIndex ?? 0);
    Array.from(track.children).forEach((c) =>
      c.classList.toggle("active", parseInt(c.dataset.realIndex) === real),
    );
    dots.forEach((d, i) => d.classList.toggle("active", i === real));
  }

  function goToTI(ti, animated = true) {
    if (isAnimating && animated) return;
    isAnimating = animated;
    currentTI = ti;
    setTransform(ti, animated);
    updateActive();
  }

  function goToReal(ri, animated = true) {
    goToTI(origTI(ri), animated);
  }

  function step(dir) {
    goToTI(currentTI + dir);
  }

  track.addEventListener("transitionend", () => {
    isAnimating = false;
    if (currentTI < total) {
      const real = parseInt(track.children[currentTI].dataset.realIndex);
      currentTI = origTI(real);
      setTransform(currentTI, false);
    } else if (currentTI >= 2 * total) {
      const real = parseInt(track.children[currentTI].dataset.realIndex);
      currentTI = origTI(real);
      setTransform(currentTI, false);
    }
  });

  // ── Auto-avance ───────────────────────────────────────────
  let autoTimer = null;
  let lightboxOpen = false;

  function startAuto() {
    stopAuto();
    if (lightboxOpen) return;
    autoTimer = setInterval(() => step(1), 4000);
  }
  function stopAuto() {
    if (autoTimer) {
      clearInterval(autoTimer);
      autoTimer = null;
    }
  }
  function resetAutoTimer() {
    stopAuto();
    startAuto();
  }

  const section = document.getElementById("gallery");
  if (section && "IntersectionObserver" in window) {
    const obs = new IntersectionObserver(
      (entries) => {
        entries[0].isIntersecting ? startAuto() : stopAuto();
      },
      { threshold: 0.3 },
    );
    obs.observe(section);
  } else {
    startAuto();
  }

  prevBtn?.addEventListener("click", () => {
    step(-1);
    resetAutoTimer();
  });
  nextBtn?.addEventListener("click", () => {
    step(1);
    resetAutoTimer();
  });

  // ── Drag / Swipe ─────────────────────────────────────────
  let dragStartX = 0,
    dragDeltaX = 0,
    isDragging = false;
  const DRAG_THRESHOLD = 50;

  function onDragStart(x) {
    isDragging = true;
    dragStartX = x;
    dragDeltaX = 0;
    track.classList.add("no-transition");
    viewport.classList.add("dragging");
    stopAuto();
  }
  function onDragMove(x) {
    if (!isDragging) return;
    dragDeltaX = x - dragStartX;
    track.style.transform = `translateX(${-offsetForTI(currentTI) + dragDeltaX}px)`;
  }
  function onDragEnd() {
    if (!isDragging) return;
    isDragging = false;
    track.classList.remove("no-transition");
    viewport.classList.remove("dragging");
    if (Math.abs(dragDeltaX) > DRAG_THRESHOLD) step(dragDeltaX < 0 ? 1 : -1);
    else setTransform(currentTI, true);
    resetAutoTimer();
  }

  viewport.addEventListener("mousedown", (e) => onDragStart(e.clientX));
  window.addEventListener("mousemove", (e) => onDragMove(e.clientX));
  window.addEventListener("mouseup", () => onDragEnd());
  viewport.addEventListener(
    "touchstart",
    (e) => onDragStart(e.touches[0].clientX),
    { passive: true },
  );
  viewport.addEventListener(
    "touchmove",
    (e) => onDragMove(e.touches[0].clientX),
    { passive: true },
  );
  viewport.addEventListener("touchend", () => onDragEnd());

  // ── Lightbox ──────────────────────────────────────────────
  const lightbox = document.getElementById("gallery-lightbox");
  const lightboxImg = document.getElementById("gallery-lightbox-img");
  const closeBtn = document.getElementById("gallery-lightbox-close");
  const lightboxPrev = document.getElementById("lightbox-prev");
  const lightboxNext = document.getElementById("lightbox-next");
  const lightboxCtr = document.getElementById("lightbox-counter");

  let lightboxIndex = 0,
    _lbScrollY = 0;

  function openLightbox(idx) {
    if (!lightbox) return;
    const item = items[idx];
    if (!item.src) return;

    lightboxOpen = true;
    stopAuto();
    lightboxIndex = idx;
    lightboxImg.src = item.src;
    if (lightboxCtr) lightboxCtr.textContent = `${idx + 1} / ${total}`;
    _lbScrollY = window.scrollY;
    document.documentElement.style.overflowY = "hidden";
    lightbox.classList.add("open");
  }

  function closeLightbox() {
    if (!lightbox?.classList.contains("open")) return;
    lightbox.classList.remove("open");
    document.documentElement.style.overflowY = "";
    window.scrollTo(0, _lbScrollY);
    lightboxOpen = false;
    startAuto();
  }

  function lightboxGoTo(idx) {
    lightboxIndex = ((idx % total) + total) % total;
    const item = items[lightboxIndex];
    if (!item.src) {
      closeLightbox();
      return;
    }
    lightboxImg.src = item.src;
    if (lightboxCtr)
      lightboxCtr.textContent = `${lightboxIndex + 1} / ${total}`;
  }

  closeBtn?.addEventListener("click", (e) => {
    e.stopPropagation();
    closeLightbox();
  });
  lightbox?.addEventListener("click", closeLightbox);
  lightboxImg?.addEventListener("click", (e) => e.stopPropagation());
  lightboxPrev?.addEventListener("click", (e) => {
    e.stopPropagation();
    lightboxGoTo(lightboxIndex - 1);
  });
  lightboxNext?.addEventListener("click", (e) => {
    e.stopPropagation();
    lightboxGoTo(lightboxIndex + 1);
  });

  document.addEventListener("keydown", (e) => {
    if (!lightbox?.classList.contains("open")) return;
    if (e.key === "Escape") closeLightbox();
    if (e.key === "ArrowLeft") lightboxGoTo(lightboxIndex - 1);
    if (e.key === "ArrowRight") lightboxGoTo(lightboxIndex + 1);
  });

  // ── Resize ───────────────────────────────────────────────
  window.addEventListener("resize", () => setTransform(currentTI, false));

  // ── Init ─────────────────────────────────────────────────
  requestAnimationFrame(() => goToReal(0, false));
}
